<template>
  <!--    LOADING -->
  <div class="cover" v-if="loading">
    <div class="mb-m">
      <smd-loading-spinner/>
    </div>
    <p>Fetching your consultations...</p>
  </div>
  <smd-one-col-layout :content-styles="contentStylesClass" v-else>

    <!--      EMPTY STATE -->
    <div class="cover"
         v-if="!sortedAppointments.length && !loading">
      <empty-state :type="'appointments'"/>
    </div>

    <!--      !EMPTY STATE -->
    <div v-if="sortedAppointments.length && !loading"
         class="smd-list--panels compact">

      <div v-if="getOnDemandBookings.length"
           class="appointment-list__filter-btns">
        <smd-btn :class="filterBtnClass('Consultations')"
                 class="btn004"
                 @click="updateActiveFilter('Consultations')">
          Consultations
        </smd-btn>
        <smd-btn :class="filterBtnClass('OnDemand')"
                 class="btn004"
                 @click="updateActiveFilter('OnDemand')">
          On-Demand
        </smd-btn>
      </div>

      <appointments-doctor-card
        v-for="(appointment,index) in displayedAppts"
        :key="index"
        :appointment="appointment"
        @click.native="apptDetails(appointment)"/>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {isCampaignOnDemandVideo} from '@leapfroggr/patientappcommons/dist/modules/on-demand';
  import {GETTER_ALL_APPOINTMENTS, GETTER_ONDEMAND_BOOKINGS} from '@/store/types';
  import {GETTER_DOCTOR_PATIENT_PARTNER, GETTER_LOADED} from '@/store/types';
  import {FILTER_ORDER} from '@/constants';
  import {
    goToAppointment,
    getFilterType,
  } from '@/utils/appointments';
  import Routes from '@/router/routes';

  import EmptyState from '@/components/empty-state';
  import AppointmentsDoctorCard from '@/components/appointments-doctor-card';

  export default {
    name: "appointments-list",
    components: {EmptyState, AppointmentsDoctorCard},
    data() {
      return {
        loading: false,
        activeFilter: 'Consultations',
      }
    },
    // watch: {
    //   loaded: {
    //     handler(value) {
          // this.loading = !value;
    //     },
    //     immediate: true,
    //   },
    // },
    computed: {
      ...mapGetters({
        loaded: GETTER_LOADED,
        getDoctorPatientPair: GETTER_DOCTOR_PATIENT_PARTNER,
        getAllAppointments: GETTER_ALL_APPOINTMENTS,
        getOnDemandBookings: GETTER_ONDEMAND_BOOKINGS,
      }),
      contentStylesClass() {
        return [{'dark-light-bg': !this.$isMobile}, 'appointment-list__content-style']
      },
      displayedAppts() {
        if (this.activeFilter === 'OnDemand') {
          return this.formatODBookings;
        }

        return this.sortedAppointments;
      },
      sortedAppointments() {
        if (!this.getAllAppointments) {
          return [];
        }

        const combinedAppts = this.getAllAppointments.concat(this.formatODBookings);

        return combinedAppts.slice(0).sort((a, b) => {
          const order_a = FILTER_ORDER[a._filterType].order;
          const order_b = FILTER_ORDER[b._filterType].order;

          if (order_a < order_b) {
            return -1;
          }

          if (order_a > order_b) {
            return 1;
          }

          return 0;
        });
      },
      formatODBookings() {
        if (!this.getOnDemandBookings.length) {
          return [];
        }

        return this.getOnDemandBookings.map(booking => ({
          ...booking,
          virtualconsult: true,
          date: new Date(booking.bookingdate),
          _filterType: getFilterType(booking),
        }));
      },
    },
    methods: {
      goToAppointment,
      apptDetails(appt) {
        if (isCampaignOnDemandVideo(appt.campaignid)) {
          this.goToODBooking(appt._id);
          return;
        }

        this.goToAppointment(appt);
      },
      filterBtnClass(val) {
        return this.activeFilter === val ? 'btn004--purple-enabled' : 'btn004--unselected';
      },
      updateActiveFilter(val) {
        this.activeFilter = val;
      },
      goToODBooking(id) {
        this.$router.push({
          name: Routes.ONDEMAND_ROOT,
          params: {bookingID: id},
        });
      },
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .appointment-list__content-style {
    > div {
      @include set-max-width($max-width: 1583px);
    }

    @include responsive('min-width: 1024px') {
      padding: space(xxl) !important;

    }
  }

  .appointment-list__filter-btns {
    @extend %layout--flex-row-center-x;
    gap: 8px;
    margin-bottom: 25px;
    margin-top: -25px;

    @include responsive("max-width: 1024px") {
      margin-top: 0px;
      margin-bottom: 20px;
    }
  }
</style>